import React from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { TooltipList } from 'packages/ui/Graph'

interface DevicesTooltipProps {
  active?: boolean
  payload?: Array<{ dataKey: string; value: number; payload: { date: string; value: number } }>
  scale?: 'day' | 'month'
}

const DevicesTooltip: React.FC<DevicesTooltipProps> = ({ active, payload, scale }) => {
  const { t, i18n } = useTranslation()

  if (!active || !payload?.[0]) return null

  const { date } = payload[0].payload
  const value = payload[0].value || 0

  const formattedDate = scale === 'month'
    ? moment(date, 'MM/YYYY').locale(i18n.language).format('MMMM YYYY')
    : moment(date, 'DD/MM').locale(i18n.language).format('dddd DD MMM YYYY')

  return (
    <TooltipList
      title={formattedDate}
      list={[
        {
          color: '#2570EB',
          label: t('event_ssids.stats.devices_over_time'),
          value: value.toString()
        }
      ]}
    />
  )
}

export default DevicesTooltip